<div class="page-area">
    <div class="row">
        <div class="col-lg-12 col-sm-12 col-xs-12">
            <div class="basic-details company-details">
                <div class="basic-title">
                    <h5>Company Master</h5>
                </div>

                <div class="company-boxes">
                    <div class="companybox">
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Company Name</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="Company Name" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Official Name</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="Official Name" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Address</h5>
                            </div>
                            <div class="emp-input">
                                <textarea nz-input placeholder="Address" nzAutosize></textarea>
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Official Address</h5>
                            </div>
                            <div class="emp-input">
                                <textarea nz-input placeholder="Official Address" nzAutosize></textarea>
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Nature of Bussiness</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="Nature of Bussiness" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Owner Name</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="Owner Name" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Owner Designation</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="Owner Designation" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Owner Name2</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="Owner Name2" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Owner Designation</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="Owner Designation" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Owner Address</h5>
                            </div>
                            <div class="emp-input">
                                <textarea nz-input placeholder="Owner Address" nzAutosize></textarea>
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Company logo</h5>
                            </div>
                            <div class="emp-input">
                                <nz-upload
                                    class="avatar-uploader"
                                    nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                    nzName="avatar"
                                    nzListType="picture-card"
                                    [nzShowUploadList]="false"
                                    [nzBeforeUpload]="beforeUpload"
                                    (nzChange)="handleChange($event)"
                                    >
                                    <ng-container *ngIf="!avatarUrl">
                                        <i class="upload-icon" nz-icon [nzType]="loading ? 'loading' : 'plus'"></i>
                                        <div class="ant-upload-text">Upload</div>
                                    </ng-container>
                                    <img *ngIf="avatarUrl" [src]="avatarUrl" style="width: 100%" />
                                </nz-upload>
                            </div>
                        </div>
                    </div>

                    <div class="companybox">
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Authorize Person 1</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="Authorize Person 1" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Authorize 1 Designation</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="Authorize 1 Designation" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Authorize 1 Address</h5>
                            </div>
                            <div class="emp-input">
                                <textarea nz-input placeholder="Authorize 1 Address" nzAutosize></textarea>
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Authorize Person 2</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="Authorize Person 2" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Person 2 Designation</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="Person 2 Designation" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Authorize Person 2 Address</h5>
                            </div>
                            <div class="emp-input">
                                <textarea nz-input placeholder="Authorize Person 2 Address" nzAutosize></textarea>
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Report Check By Designation</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="Report Check By Designation" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Contact No.</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="Contact No." [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Email ID</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="Email ID" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Website</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="Website" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>CIT(TDS) Address</h5>
                            </div>
                            <div class="emp-input">
                                <textarea nz-input placeholder="CIT Address" nzAutosize></textarea>
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Qwner Photo</h5>
                            </div>
                            <div class="emp-input">
                                <nz-upload
                                    class="avatar-uploader"
                                    nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                    nzName="avatar"
                                    nzListType="picture-card"
                                    [nzShowUploadList]="false"
                                    [nzBeforeUpload]="beforeUpload"
                                    (nzChange)="handleChange($event)"
                                    >
                                    <ng-container *ngIf="!avatarUrl">
                                        <i class="upload-icon" nz-icon [nzType]="loading ? 'loading' : 'plus'"></i>
                                        <div class="ant-upload-text">Upload</div>
                                    </ng-container>
                                    <img *ngIf="avatarUrl" [src]="avatarUrl" style="width: 100%" />
                                </nz-upload>
                            </div>
                        </div>
                    </div>

                    <div class="companybox">
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>PAN No</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="PAN No" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>TAN No</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="TAN No" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>CIT Pin Code</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="CIT Pin Code" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>CITY</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="CITY" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>STATE</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="STATE" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>PT NO</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="PT NO" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>PF NO</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="PF NO" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>ESIC NO</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="ESIC NO" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Reg. No(CIN)</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="Reg. No" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Reg. Date</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="Reg. Date" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>License No</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="License No" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>Laber Identification No</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="Laber Identification No" [(ngModel)]="value" />
                            </div>
                        </div>
                        <div class="basic-cont">
                            <div class="emp-title">
                                <h5>LWF EST. Code</h5>
                            </div>
                            <div class="emp-input">
                                <input nz-input placeholder="LWF EST. Code" [(ngModel)]="value" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grace-btnbox">
                    <ul>
                        <li><a href="javascript:void(0);">Save</a></li>
                        <li><a href="javascript:void(0);">Close</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>